import React, { useEffect, useState } from "react";
import {
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    InputGroup,
    InputGroupAddon,
    Spinner,
    CustomInput,
} from "reactstrap";
import { updateOffer } from 'service/offer.service';
import { FaPlus } from "react-icons/fa";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const Step3Form = ({
    formData,
    handleChange,
    handleNextStep,
    handlePreviousStep,
}) => {
    const [offerData, setFormData] = useState({
        id: 0,
        offer_name: "",
        offer_short_description: "",
        offer_long_description: "",
        offer_package_name: "",
        advertiser: "",
        offer_small_icon: "",
        offer_medium_icon: "",
        offer_large_icon: "",
        offer_banner_image: "",
        offer_revenue: "",
        offer_payout: "",
        offer_user_reward: "",
        offer_type: "",
        offer_app_preview_required: false,
        offer_app_title: "",
        offer_app_description: "",
        offer_video_link: "",
        is_video_available: false,
    });
    const [step, setStep] = useState(3);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const modules = {
        toolbar: [
            [{ header: "1" }, { header: "2" }, { font: [] }],
            [{ size: [] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [
                { list: "ordered" },
                { list: "bullet" },
                { indent: "-1" },
                { indent: "+1" },
            ],
            ["link", "image", "video"],
            ["clean"],
        ],
        clipboard: {
            // toggle to add extra line breaks when pasting HTML:
            matchVisual: false,
        },
    };
    useEffect(() => {
        console.log(formData);
        setFormData((prevData) => ({
            ...prevData,
            ...formData
        }));
    }, [formData]);

    //   const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData((prevData) => ({
    //       ...prevData,
    //       [name]: value,
    //     }));
    //   };

    const handleEditorChange = (value) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            offer_app_description: value,
        }));
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));



    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        // Simulate an asynchronous submission process
        setTimeout(() => {
            setIsSubmitting(false);
            // Handle form submission here
        }, 2000);
    };

    const handleBack = () => {
        setStep((prevStep) => prevStep - 1);
    };

    const handleContinue = () => {
        setStep((prevStep) => prevStep + 1);
    };
    const handleUpdate = async(e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        console.log(offerData);


        // Simulate an asynchronous submission process
        try {
            const offerAdded = await updateOffer(offerData.id, offerData);
            console.log(offerAdded);
            if (offerAdded.status === 200) {
                handleChange(offerAdded.data.result);

                setIsSubmitting(false);
                setStep((prevStep) => prevStep + 1);
                handleNextStep();
                handleNextStep();



            }

        } catch (error) {
            console.error('Error adding advertiser:', error);
        }
    };
    const { offer_app_preview_required, is_video_available } = offerData;

    return ( <
        div className = "" >
        <
        div className = "mb-3 d-flex align-items-center justify-content-between" >
        <
        div > Enter App Details < /div> {
            offerData.id > 0 ? ( <
                span className = "badge badge-success badge-sm my-auto ms-auto me-3 text-dark" >
                Offer Id: < strong > { offerData.id } < /strong> <
                /span>
            ) : null
        } <
        /div> <
        form >
        <
        fieldset className = "custom-fieldset mt-3" >
        <
        legend className = "custom-legend" > App Description < /legend>

        <
        FormGroup >
        <
        CustomInput type = "switch"
        id = "isLocationTargetting"
        name = "offer_app_preview_required"
        label = "Is App Preview Required"
        checked = { offer_app_preview_required }
        onChange = {
            () =>
            setFormData((prevFormData) => ({
                ...prevFormData,
                offer_app_preview_required:
                    !prevFormData.offer_app_preview_required,
            }))
        }
        /> <
        /FormGroup> {
            offer_app_preview_required && ( <
                div className = "row" >
                <
                div className = "col-md-12" >
                <
                FormGroup >
                <
                Label
                for = "email" > Title < /Label> <
                Input type = "text"
                name = "offer_app_title"
                id = "title"
                onChange = { handleInputChange }
                value = { offerData.offer_app_title }
                placeholder = "About the App" /
                >
                <
                /FormGroup> <
                /div> <
                div className = "col-md-12" >
                <
                FormGroup >
                <
                Label
                for = "name" > Long Description < /Label> <
                ReactQuill value = { offerData.offer_app_description }
                onChange = { handleEditorChange }
                theme = "snow"
                modules = { modules }
                placeholder = "Write something awesome..." /
                >
                <
                /FormGroup> <
                /div> <
                /div>
            )
        } <
        /fieldset>

        <
        fieldset className = "custom-fieldset mt-3" >
        <
        legend className = "custom-legend" > App Tutorial < /legend>

        <
        FormGroup >
        <
        CustomInput type = "switch"
        id = "name"
        name = "is_video_available"
        label = "Is Video Required"
        checked = { is_video_available }
        onChange = {
            () =>
            setFormData((prevFormData) => ({
                ...prevFormData,
                is_video_available: !prevFormData.is_video_available,
            }))
        }
        /> <
        /FormGroup>

        {
            is_video_available && ( <
                div className = "row" >
                <
                div className = "col-md-12" >
                <
                FormGroup >
                <
                Label
                for = "email" > Video Link < /Label> <
                Input type = "text"
                name = "offer_video_link"
                id = "title"
                onChange = { handleInputChange }
                value = { offerData.offer_video_link }
                placeholder = "About the App" /
                >
                <
                /FormGroup> <
                /div> <
                /div>
            )
        } <
        /fieldset> <
        div className = "d-flex justify-content-between mt-3" > {
            step > 1 && ( <
                Button type = "button"
                color = "secondary"
                onClick = { handlePreviousStep } >
                Back <
                /Button>
            )
        }

        {
            step === 3 && ( <
                Button type = "submit"
                color = "primary"
                disabled = { isSubmitting }
                onClick = { handleNextStep } > { isSubmitting ? < Spinner size = "sm"
                    color = "light" / > : "Submit & Next" } <
                /Button>
            )
        } <
        /div>

        <
        /form> <
        /div>
    );
};

export default Step3Form;